import { render } from "./LwTabs.vue?vue&type=template&id=d87508fc&scoped=true"
import script from "./LwTabs.vue?vue&type=script&lang=js"
export * from "./LwTabs.vue?vue&type=script&lang=js"

import "./LwTabs.vue?vue&type=style&index=0&id=d87508fc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d87508fc"]])

export default __exports__